import { render, staticRenderFns } from "./OrderDetailCatalogueForm.vue?vue&type=template&id=2c631c4f&"
import script from "./OrderDetailCatalogueForm.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailCatalogueForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports